import {Component, ElementRef, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
declare const ResizeObserver: any;

@Component({
  selector: 'virtual-scroll',
  templateUrl: './virtual-scroll.component.html',
  styleUrls: ['./virtual-scroll.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VirtualScrollComponent implements OnInit {
  _data: Array<any> = [];
  @Input('containerHeight') containerHeight: number;
  @Input('rowHeight') rowHeight: number = 0;
  @Input('items') items: number = -1;
  @Input('rowsError') rowsError: any[] = [];
  @Input() checkItemsExist: boolean;
  @Input('template') template: TemplateRef<any>;
  @Input('vsStyleRow') vsStyleRow: any = {}
  @Input('data') set data(d: Array<any>) {
    this._data = d?d:[];
    this.render(0);
  }

  @ViewChild('vs') vsContainer: ElementRef;

  ctx: any = {rows: []}
  scrollStyle: any = {"height": "0px", "width": "1px"};
  vsStyle: any = {"position": "relative", "height": '100%'};

  constructor() {
  }

  ngOnInit() {
    // todo calc items showing by height vs
    // Math.round($0.clientHeight / 50);
  }

  scroll(ev) {
    const p = Math.floor((ev.target.scrollTop / this.rowHeight));
    this.render(p);
  }

  render(p) {
    if(this.items < 1) {
      console.log({p, i: this.items})
      this.items =  Math.floor(this.vsContainer.nativeElement.clientHeight / this.rowHeight);
    }
    this.vsStyle.height = (this.containerHeight || (this.items * this.rowHeight)+ 'px' ) ;
    this.scrollStyle.height = (this._data.length * this.rowHeight) + 'px';
   if (this.checkItemsExist)
    this.ctx.rows = this._data.map((row, index) => {
      return {item: row, index: index + p}
    });
   else {
     let rowErrorIndex = this.rowsError.filter(r=> !r.message).map(r=> r.index);
     this.ctx.rows = this._data.filter(b=> !rowErrorIndex.includes(b.index)).slice(p, this.items + p).map((row, index) => {
       return {item: row, index: index + p}
     });
   }
  }

  getRowStyle(index) {
    return {
      ...this.vsStyleRow,
      "position": "absolute",
      "top": (this.rowHeight * index) + 'px',
      "height": (this.rowHeight) + 'px',
      "--rot": (this.rowHeight * index)
    }
  }

  getD() {
    console.log("this._data 2 this.ctx: ",this.ctx.rows);
    return this.ctx.rows;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/virtual-scroll/virtual-scroll.component.ts